import type { AllRouteEndpoints } from "../routeTypes";

export const aiAgentGeminiInteractionsAppGroupId = "/ai_agent/gemini_interactions/:app_group_id";

export const aiAgentGeminiInteractionsAppGroupIdCacheKeys: AllRouteEndpoints[] = [];
